// Russian
export const ru = {
  'app.name':           'Kardolive',
  'app.tagline':        'Портал клиента',
  'app.signOut':        'Выйти',

  'login.email':        'Эл. почта',
  'login.password':     'Пароль',
  'login.signIn':       'Войти',
  'login.signingIn':    'Выполняется вход…',
  'login.failed':       'Ошибка входа',
  'login.newAccount':   'Новичок в Kardolive?',
  'login.createAccount':'Создать бесплатный аккаунт →',

  'nav.workspace':      'Рабочее пространство',
  'nav.templates':      'Шаблоны',
  'nav.live':           'Трансляции',
  'nav.rooms':          'Комнаты и чат',
  'nav.content':        'Контент',
  'nav.developer':      'Разработчик',
  'nav.account':        'Аккаунт',

  'nav.overview':       'Обзор',
  'nav.projects':       'Проекты',
  'nav.chat':           'Консоль чата',
  'nav.sessions':       'Сессии',
  'nav.streams':        'Прямые трансляции',
  'nav.studio':         'Студия',
  'nav.recordings':     'Записи',
  'nav.apiKeys':        'API-ключи',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Тестер Webhook',
  'nav.networkTest':    'Тест сети',
  'nav.embed':          'Встраиваемые виджеты',
  'nav.sdk':            'SDK и документация',
  'nav.docs':           'Документация',
  'nav.analytics':      'Аналитика',
  'nav.settings':       'Настройки',

  'overview.welcome':       'С возвращением, {name}',
  'overview.plan':          '{tenant} · план {plan}',
  'overview.newStream':     'Новая трансляция',
  'overview.kpi.live':           'Сейчас в эфире',
  'overview.kpi.live.broadcasting': 'трансляций идёт',
  'overview.kpi.live.nothing':    'нет активных',
  'overview.kpi.total':           'Всего трансляций',
  'overview.kpi.total.sub':       'за всё время',
  'overview.kpi.sessions':        'Сеансы · 30 дней',
  'overview.kpi.sessions.sub':    'события публикации',
  'overview.kpi.recordings':      'Записи',
  'overview.kpi.recordings.sub':  'готовы к воспроизведению',
  'overview.recentStreams':       'Недавние трансляции',
  'overview.recentSessions':      'Недавние сеансы',
  'overview.viewAll':             'Показать все →',
  'overview.empty.title':         'Трансляций пока нет',
  'overview.empty.body':          'Создайте первую трансляцию, чтобы начать вещание.',
  'overview.empty.action':        'Создать трансляцию',
  'overview.noSessions':          'Сеансов пока нет',

  'status.live':        'В ЭФИРЕ',
  'status.idle':        'ОЖИДАНИЕ',
  'status.ended':       'ЗАВЕРШЕНО',
  'status.archived':    'В АРХИВЕ',

  'common.save':        'Сохранить',
  'common.cancel':      'Отмена',
  'common.delete':      'Удалить',
  'common.edit':        'Изменить',
  'common.create':      'Создать',
  'common.confirm':     'Подтвердить',
  'common.loading':     'Загрузка…',
  'common.error':       'Ошибка',
  'common.retry':       'Повторить',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Перейти к содержимому страницы",
  "nav.streamTemplates": "Шаблоны трансляций",
  "nav.boards": "Интерактивные доски",
  "nav.menu": "Открыть навигацию",
  "nav.closeMenu": "Закрыть навигацию",
  "nav.scenarios": "Сценарии",
  "nav.premieres": "Премьеры",
  "nav.clips": "Клипы",
  "dashboard.account": "Аккаунт",
  "dashboard.language": "Язык",
  "dashboard.appearance": "Оформление",
  "nav.allStreams": "Все трансляции",
  "nav.destinations": "Направления ретрансляции",
  "nav.ecommerce": "Электронная торговля",
  "nav.products": "Товары",
  "nav.services": "Услуги",
  "nav.collections": "Коллекции",
  "nav.orders": "Заказы",
  "nav.commerceSettings": "Настройки торговли",
  "nav.engagement": "Взаимодействие",
  "theme.light": "Переключить на светлую тему",
  "theme.dark": "Переключить на тёмную тему",
  "role.owner": "Владелец",
  "role.admin": "Администратор",
  "role.member": "Участник",
  "role.viewer": "Наблюдатель",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Активные",
  "streams.archived": "В архиве",
  "streams.monitor": "Монитор источников",
  "streams.create": "Создать прямой эфир",
  "streams.list": "Список",
  "streams.grid": "Сетка",
  "streams.view": "Вид списка трансляций",
  "streams.searchLabel": "Поиск мероприятий",
  "streams.searchHint": "Поиск по названию",
  "streams.solutionFilter": "Фильтр по типу мероприятия",
  "streams.statusFilter": "Фильтр по статусу",
  "streams.dateFilter": "Фильтр по дате создания",
  "streams.allSolutions": "Все типы",
  "streams.custom": "Существующая или своя настройка",
  "streams.allStatuses": "Все статусы",
  "streams.anyTime": "Любая дата создания",
  "streams.last7": "Созданы за последние 7 дней",
  "streams.last30": "Созданы за последние 30 дней",
  "streams.count": "Показано мероприятий: {shown} из {total}",
  "streams.noMatch": "Нет мероприятий, соответствующих фильтрам.",
  "streams.clearFilters": "Сбросить фильтры",
  "streams.refreshFailed": "Не удалось обновить список",
  "streams.loadFailed": "Не удалось загрузить трансляции",
  "streams.stale": "Показан ранее загруженный список. Статусы могли измениться.",
  "streams.connectionHint": "Проверьте подключение и загрузите список снова.",
  "streams.retrying": "Повторная попытка…",
  "streams.retry": "Повторить",
  "streams.restoreFailed": "Не удалось восстановить трансляцию",
  "streams.restoreHint": "Проверьте подключение и обновите список, чтобы уточнить статус перед повторной попыткой.",
  "streams.unused": "Неиспользованные трансляции: {count}",
  "streams.unusedHint": "Нет эфиров или записей для просмотра. Архивирование упорядочит список, ничего не удаляя.",
  "streams.reviewArchive": "Просмотреть и архивировать",
  "streams.loading": "Загрузка трансляций…",
  "streams.archiveEmpty": "Архив пуст. Архивные трансляции и их записи остаются здесь до восстановления.",
  "streams.restore": "Восстановить",
  "streams.firstTitle": "Создайте первую трансляцию",
  "streams.firstBody": "Выберите настройку для продаж, занятий или услуг либо начните с пустой трансляции. Ведите эфир из браузера, с телефона или через OBS.",
  "streams.blank": "Пустая трансляция",
  "streams.broadcasts": "Эфиры: {count}",
  "streams.replays": "Повторы: {count}",
  "streams.sessions": "Сессии: {count}",
  "streams.recordings": "Записи: {count}",
  "streams.mode.BROADCAST": "Вещание",
  "streams.mode.LOW_LATENCY": "Низкая задержка",
  "streams.mode.REALTIME": "В реальном времени",
  "streams.key": "Ключ",
  "streams.archiveTitle": "Архивировать неиспользованные трансляции",
  "streams.archiveHint": "Эти трансляции ещё не выходили в эфир. Их можно восстановить в любой момент на вкладке «В архиве».",
  "streams.archiveFailed": "Не удалось архивировать {count} трансляций: возможно, они уже вышли в эфир. Остальные архивированы.",
  "streams.archiving": "Архивирование…",
  "streams.archiveCount": "Архивировать: {count}",
  "streamType.webinar": "Бизнес-вебинары и презентации",
  "streamType.classroom": "Уроки и репетиторство",
  "streamType.training": "Корпоративное обучение",
  "streamType.conference": "Конференции и выставки",
  "streamType.shopping": "Покупки в прямом эфире",
  "streamType.auction": "Аукционы в прямом эфире",
  "streamType.consultation": "Частные консультации",
  "streamType.creator": "Эфиры авторов и сообществ",
  "streamType.audio": "Аудиокомнаты и подкасты",
  "streamType.sports": "Спорт и киберспорт",
  "streamType.performance": "Концерты и выступления",
  "streamType.community": "Богослужения и сбор средств",
  "streamType.tour": "Экскурсии и демонстрации",
  "streamType.fitness": "Фитнес и мастер-классы",
  "streamType.public-meeting": "Новости и публичные собрания",
  "streamType.continuous": "Непрерывные каналы и камеры",
  "streams.close": "Закрыть",
};
